import { AxiosResponse } from 'axios'
import { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { createContext, useContext, useEffect } from 'react'
import { RefetchOptions, RefetchQueryFilters, QueryObserverResult } from 'react-query'
import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { MainContent } from '../../../components/MainContent'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'
import { Recap } from '../../../containers/carkulka/Recap'
import { RecapExtraInsurance } from "../../../containers/carkulka/RecapExtraInsurance.1"
import { InsuranceInfo } from '../../../containers/InsuranceInfo/InsuranceInfo'
import { MeetingRecordForm } from '../../../containers/MeetingRecordForm'
import { addonOffersContext, AddonOffersProvider } from '../../../context/OfferAddonContext'
import { useGetMeetingRecord } from '../../../hooks/useWizard'
import { insurerOfferContext, WithOffer } from '../../../containers/hoc/WithOffer'
import { insuranceParamsContext } from '../../../layouts/Wizard'
import { CompletedPage } from './completed'
import { WithAuth } from '../../../containers/hoc/WithAuth'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { OkAppsMeetingRecord } from '../../../dtos/OkAppsMeetingRecord'
import { useNavigate } from 'react-router-dom'

type MeetingRecordCtxProps = {
  meetingRecord?: OkAppsMeetingRecord
  isLoading: boolean
  refetch: <TPageData>(options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined) => Promise<QueryObserverResult<AxiosResponse<OkAppsMeetingRecord, any>, any>>
}

export const meetingRecordContext = createContext<MeetingRecordCtxProps>({} as MeetingRecordCtxProps)

const _Step5Wrapper = () => {
  const { insuranceParams } = useContext(insuranceParamsContext)
  const { offer } = useContext(insurerOfferContext)

  if (!insuranceParams) return null

  return (
    <AddonOffersProvider insuranceParams={insuranceParams as InsuranceParamsDto} offer={offer}>
      <_Step5 />
    </AddonOffersProvider>
  )
}

const _Step5 = () => {
  const navigate = useNavigate()
  const { insuranceParams, insuranceParamsId, isLoadingData } = useContext(insuranceParamsContext)
  const { refetch: refetchAddonOffers, addonOffers } = useContext(addonOffersContext)

  const isContracted = !!insuranceParams?.generalParams.contractNumber

  // get formulare
  const { isLoading, isFetching, data, refetch } = useGetMeetingRecord(insuranceParamsId!, { enabled: false, cacheTime: 0 })

  if (!isLoadingData && insuranceParams && (insuranceParams.generalParams?.lastWizardStep ?? 1) < 5) {
    navigate('/carkulka/wizard/too-far', { replace: true })
  }

  // vynuceni nacteni dat
  useEffect(() => {
    if (!!insuranceParamsId) {
      refetch()
      refetchAddonOffers()
    }
  }, [insuranceParamsId])

  const offerId = insuranceParams?.generalParams.selectedOfferId

  useEffect(() => { if (!!offerId) refetch() }, [offerId])

  return (
    <Section>
      <Container>
        <meetingRecordContext.Provider
          value={{
            isLoading: isFetching || isLoading,
            refetch: refetch,
            meetingRecord: data?.data
          }}>

          {isLoadingData && <Loading large={true} />}

          {!isContracted && !!insuranceParams && !isLoadingData &&
            <StepsContent step={5}>
              <Steps icon="car" />

              <InsuranceInfo />

              <MainContent>
                <Recap />

                {addonOffers.length > 0 && <RecapExtraInsurance />}

                <MeetingRecordForm />
              </MainContent>
            </StepsContent>
          }

          {isContracted && !!insuranceParams && <CompletedPage />}
        </meetingRecordContext.Provider>

        <WizardForbiddenMessage />
      </Container>
    </Section >
  )
}

export const Step5 = WithOffer(WithAuth(_Step5Wrapper))